import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GlobalMessageType } from '../../../global-message/models/global-message.model';
import { GlobalMessageActions } from '../../../global-message/store/actions/index';
import { normalizeHttpError } from '../../../util';
import { UserProfileConnector } from '../../connectors/user-profile.connector';
import { ForgotPasswordActionTypes } from '../actions/forgot-password.action';
import { UserActions } from '../actions/index';

@Injectable()
export class ForgotPasswordEffects {
  requestForgotPasswordEmail$: Observable<
    UserActions.ForgotPasswordEmailRequestSuccess | UserActions.ForgotPasswordEmailRequestFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ForgotPasswordActionTypes.RequestForgottenPasswordEmail),
      map((action: UserActions.ForgotPasswordEmailRequest) => action.payload),
      switchMap(({ email, username }) => {
        return this.userProfileConnector.requestForgotPasswordEmail(email, username).pipe(
          map(() => new UserActions.ForgotPasswordEmailRequestSuccess()),
          catchError((error) => of(new UserActions.ForgotPasswordEmailRequestFail(normalizeHttpError(error))))
        );
      })
    )
  );

  //For safety reason, even if user email doesn't exist in database (failed response) we don't want to show this.
  handleSuccessOrError$: Observable<GlobalMessageActions.AddMessage> = createEffect(() =>
    this.actions$.pipe(
      ofType(
        ...[
          ForgotPasswordActionTypes.RequestForgottenPasswordEmailSuccess,
          ForgotPasswordActionTypes.RequestForgottenPasswordEmailFail,
        ]
      ),
      map(
        () =>
          new GlobalMessageActions.AddMessage({
            text: { key: 'password.forgotten.emailSendSuccess_message' },
            type: GlobalMessageType.MSG_TYPE_CONFIRMATION,
          })
      )
    )
  );

  constructor(private actions$: Actions, private userProfileConnector: UserProfileConnector) {}
}
